import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { WhatsAppNewClientService } from './whats-app-new-client.service';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

interface ConversationItem {
  message: string;
  created_at: string;
  is_ai: boolean;
}

@Component({
  selector: 'calsoft-whats-app-new-client',
  templateUrl: './whats-app-new-client.component.html',
  styleUrls: ['./whats-app-new-client.component.scss']
})
export class WhatsAppNewClientComponent implements OnInit, AfterViewInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() phoneNumber: any;
  data: any;
  //   data: any = {
  //     message: 'Whatsapp Messages',
  //     conversations: [],
  //     count: 0
  //   };
  //   inputs for API
  apiUrlInput = 'https://api.botneu.in/external/conversation/916380506146';
  // prefill with provided key — you can change or clear this in the UI
  apiKeyInput = '0ceb8d3e5e8404ef9132c28927eac6cf9eb1c6e41fc59cedb2e0e2f6947d2027';
  limit = 10; // page size
  // page index (0-based)
  page = 0;
  // track last API offset requested (items skipped) to avoid duplicate requests
  lastRequestedOffset: number | null = null;
  loading = false;
  hasMore = true;
  // debug helpers
  lastResponse: any = null;
  lastError: string | null = null;
  @ViewChild('chatBody') chatBody?: ElementRef<HTMLDivElement>;
  private _boundScrollHandler: any = null;
conversations:any=[];
  constructor(private apiService: WhatsAppNewClientService, private router: Router) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      }); }

  ngOnInit(): void {

    // ensure data shape exists
    if (!this.data) {
      this.data = { message: 'Whatsapp Messages', conversations: [], count: 0 };
    }

    this.fetchPage();
    // start with empty conversations until user loads via the API input
    // this.data = {
    //   message: 'Whatsapp Messages',
    //       "conversations": [
    //     // {
    //     //     "message": "How to use",
    //     //     "created_at": "2025-11-04T01:37:36.474Z",
    //     //     "is_ai": false
    //     // },
    //     // {
    //     //     "message": "[\"skin\",\"Soap\",\"gift\",\"Skincare\",\"Hair Oil\",\"soap\",\"Hair oil\",\"Emp\"]",
    //     //     "created_at": "2025-11-03T09:55:24.417Z",
    //     //     "is_ai": true
    //     // },
    //     // {
    //     //     "message": "\"Hello! Welcome to Herbs Leaf Cosmetics. How can I assist you today?\"",
    //     //     "created_at": "2025-11-03T09:55:22.689Z",
    //     //     "is_ai": true
    //     // },
    //     // {
    //     //     "message": "Hlo",
    //     //     "created_at": "2025-11-03T09:55:18.085Z",
    //     //     "is_ai": false
    //     // },
    //     // {
    //     //     "message": "[\"skin\",\"Soap\",\"gift\",\"Skincare\",\"Hair Oil\",\"soap\",\"Hair oil\",\"Emp\"]",
    //     //     "created_at": "2025-11-03T09:54:54.749Z",
    //     //     "is_ai": true
    //     // },
    //     // {
    //     //     "message": "\"Hello there! Welcome to Herbs Leaf Cosmetics. We're delighted to have you here!\"",
    //     //     "created_at": "2025-11-03T09:54:52.989Z",
    //     //     "is_ai": true
    //     // },
    //     // {
    //     //     "message": "Hi",
    //     //     "created_at": "2025-11-03T09:54:48.150Z",
    //     //     "is_ai": false
    //     // },
    //     // {
    //     //     "message": "\"Certainly! Here's more information about our Herbs Leaf Beard Oil:\\n\\n*Product Name:* Beard Oil\\n*Price:* ₹299\\n*Category:* Skincare\\n\\n*Description:\\nHerbs Leaf Beard Oil is the ultimate grooming essential, a perfect blend of nature’s finest ingredients. It is specially formulated to hydrate, soften, and nourish your beard. This lightweight, non-greasy oil penetrates deep into each strand, promoting healthier and stronger beard growth.\\n\\nKey Benefits:\\n   *Hydration:* Moisturizes dry, brittle hair and soothes the skin beneath.\\n*   *Smoothness:* Tames unruly beard hair for a polished look.\\n*   *Growth:* Infused with natural herbs to stimulate healthy beard growth.\\n*   *Freshness:* Features a subtle herbal fragrance for all-day confidence.\\n\\nFor any further details, you can contact Pradeepa at 9500455018.\"",
    //     //     "created_at": "2025-11-03T09:10:07.940Z",
    //     //     "is_ai": true
    //     // },
    //     // {
    //     //     "message": "Beard Oil - Hello! Can I get more info on this?",
    //     //     "created_at": "2025-11-03T09:09:53.924Z",
    //     //     "is_ai": false
    //     // }
    // ],
    //   count: 0
    // };
  }

  isJsonArray(text: string): boolean {
    try {
      const parsed = JSON.parse(text);
      return Array.isArray(parsed);
    } catch (e) {
      return false;
    }
  }

  parseJsonArray(text: string): string[] {
    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) {
        return parsed;
      }
      return [text];
    } catch (e) {
      return [text];
    }
  }

  /**
   * Convert a JSON-array string into a Markdown string.
   * Each array element will be a bullet item. If parsing fails, returns the original text.
   */
  jsonArrayToMarkdown(text: string): string {
    const arr = this.parseJsonArray(text);
    if (!arr || arr.length === 0) {
      return text;
    }
    // produce a markdown list
    return arr.map((t: any) => `- ${t}`).join('\n');
  }

  /**
   * Normalize incoming message text: unquote JSON-encoded strings so escaped newlines
   * and inner quotes become actual characters. If parsing fails, return original.
   */
  normalizeMessage(text: string): string {
    if (typeof text !== 'string') return text as any;
    const trimmed = text.trim();
    // If it's a JSON-encoded string (starts/ends with double quotes), parse it to unescape sequences
    if ((trimmed.startsWith('"') && trimmed.endsWith('"')) || (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
      try {
        return JSON.parse(trimmed);
      } catch (e) {
        return text;
      }
    }
    return text;
  }

  /**
   * Render markdown text to sanitized HTML using marked + DomSanitizer.
   */
  // Markdown rendering is handled by ngx-markdown in the template.

  /**
   * Add query params to a base URL safely.
   */
  private addQueryParams(url: string, params: { [k: string]: any }) {
    const hasQ = url.indexOf('?') !== -1;
    const qp = Object.keys(params)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join('&');
    return url + (hasQ ? '&' : '?') + qp;
  }

  /**
   * Load the first page (reset) using the provided apiUrlInput and apiKeyInput.
   */
  loadFirstPage() {
    this.page = 0;
    this.lastRequestedOffset = null;
    if (this.data) this.data.conversations = [];
    this.hasMore = true;
    this.fetchPage();
  }

  /**
   * Fetch a page from the API and append to current conversations.
   */
  fetchPage(pageToFetch?: number, prepend: boolean = false) {
    if (!this.apiUrlInput) {
      return;
    }
    if (!this.hasMore || this.loading) {
      return;
    }
    // determine which page to fetch (explicit param wins)
    const p = (typeof pageToFetch === 'number') ? pageToFetch : this.page || 0;
    // compute API offset as number of items to skip (service expects item-skip)
    const apiOffset = p;

    // avoid re-requesting the same page while another request for it is in-flight
    if (this.lastRequestedOffset === p) {
      return;
    }

    this.lastRequestedOffset = p;
    this.loading = true;

    // record previous scrollHeight when prepending so we can restore viewport
    const prevScrollHeight = (prepend && this.chatBody && this.chatBody.nativeElement) ? this.chatBody.nativeElement.scrollHeight : 0;

    this.apiService.getAllWhatsAppChat(apiOffset, this.limit, this.phoneNumber).subscribe(
      (res: any) => {

        this.conversations=[...this.conversations, ...(res.data.conversations || [])];



        // If returned items are fewer than limit, assume there is no more data
        if (res.data.conversations.length ==0) {
          this.hasMore = false;
        }

        // clear in-flight marker
        this.lastRequestedOffset = null;
        this.loading = false;

        // If we prepended, restore scrollTop so viewport remains at same message
        if (prepend && this.chatBody && this.chatBody.nativeElement) {
          setTimeout(() => {
            try {
              const el = this.chatBody!.nativeElement;
              const newScrollHeight = el.scrollHeight;
              el.scrollTop = newScrollHeight - prevScrollHeight;
            } catch (e) { /* ignore */ }
          }, 0);
        }
      },
      err => {
        console.error('API fetch error', err);
        this.lastError = err && err.message ? err.message : (err && err.statusText ? err.statusText : JSON.stringify(err));
        this.loading = false;
        this.hasMore = false;
      }
    );
  }
  showScrollButton = false;
  checkScrollPosition() {
    if (this.chatBody) {
      const element = this.chatBody.nativeElement;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
      this.showScrollButton = !atBottom;
    }
  }

  onScroll(e: any) {
    const el = e.target;
    if (!el) { return; }
    const threshold = 120; // px from bottom to trigger
    const position = el.scrollTop + el.clientHeight;
    const height = el.scrollHeight;
    if (position > height - threshold) {
      // do not trigger if already loading or no more
      if (this.loading || !this.hasMore) { return; }

      // compute next page index
      const nextPage = (this.page || 0) + 1;
      const nextApiOffset = nextPage * this.limit;
      // avoid duplicate requests for the same offset
      if (this.lastRequestedOffset === nextApiOffset) { return; }

      // set page and fetch that page
      this.page = nextPage;
      this.fetchPage(this.page);
    }
  }

  formatDate(iso: string) {
    return new Date(iso).toLocaleString();
  }
 ngAfterViewChecked() {
    this.checkScrollPosition();
  }


    ngAfterViewInit() {
    this.chatBody.nativeElement.addEventListener('scroll', (event) => {

      if( !this.hasMore) { return; }
       const nextPage = (this.page || 0) + 1;
     this.page = nextPage;
      this.fetchPage(this.page);
    });
   
  }


  ngOnDestroy(): void {
    if (this.chatBody && this.chatBody.nativeElement && this._boundScrollHandler) {
      this.chatBody.nativeElement.removeEventListener('scroll', this._boundScrollHandler);
    }
      this._onDestroy.next();
      this._onDestroy.complete();
  }

    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }
}
